module.exports = __webpack_public_path__ + "27aff81ecdbf72d35092c0e5d0b72a2d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-26.png
// module id = 1981
// module chunks = 0